import { render, staticRenderFns } from "./LikesModal.vue?vue&type=template&id=de95d6e4&"
import script from "./LikesModal.vue?vue&type=script&lang=js&"
export * from "./LikesModal.vue?vue&type=script&lang=js&"
import style0 from "./LikesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports